// extracted by css-extract-rspack-plugin
export default {"uploadFileName":"rSdEMfq4PIktkUfP","buttonDelete":"oLjmn3yw90M8Kudk"};